var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"details_div"},[_c('div',{staticClass:"details_title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"details_time"},[_vm._v(_vm._s(_vm.time))])]),_c('div',{staticClass:"details_content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }